module.exports = __webpack_public_path__ + "fonts/SFProDisplay-Medium.423da333.eot";